import 'css-chunk:src/logoTransitionOverlay/logoTransitionOverlay.module.scss';export default {
  "overlayRoot": "logoTransitionOverlay-module__overlayRoot___N4rxX",
  "overlay-fade-in": "logoTransitionOverlay-module__overlay-fade-in___IaxCy",
  "overlayRoot--fading": "logoTransitionOverlay-module__overlayRoot--fading___lKjnB",
  "overlayRoot--backdropFading": "logoTransitionOverlay-module__overlayRoot--backdropFading___BVg43",
  "mediaWrapper": "logoTransitionOverlay-module__mediaWrapper___aNzsJ",
  "mediaWrapper--fading": "logoTransitionOverlay-module__mediaWrapper--fading___qBbY-",
  "mediaWrapper--running": "logoTransitionOverlay-module__mediaWrapper--running___-XcCE",
  "mediaElement": "logoTransitionOverlay-module__mediaElement___lHvO-",
  "handoffSvg": "logoTransitionOverlay-module__handoffSvg___8Ir7w",
  "handoffSvg--visible": "logoTransitionOverlay-module__handoffSvg--visible___Gyzwv",
  "handoffSvg--running": "logoTransitionOverlay-module__handoffSvg--running___DyKLp",
  "closeButton": "logoTransitionOverlay-module__closeButton___Hp0zV",
  "closeButton--fading": "logoTransitionOverlay-module__closeButton--fading___D9SVU"
};